export default null;

export const getRoomShortTitle = (beforeShortenTitle = "") => {
  let title = "";
  if (beforeShortenTitle) {
    if (beforeShortenTitle.includes("Villa")) {
      title = beforeShortenTitle.replace(/\(|\)|bedrooms?/gi, "");
    } else if (beforeShortenTitle.toLowerCase() === "superlux cabin") {
      title = "SLC";
    } else {
      const titles = beforeShortenTitle.split(" ");
      titles.forEach((x, i) => {
        title += x.replace(/[a-z]/g, "");
      });
      //   if (titles.length > 1) title += titles[1].charAt(0).toUpperCase();
    }
  }
  return title;
};
